<template>
  <span
    v-if="inlineEditMode && offerEditMode"
    class="link-field-fi--inline-edit"
    @click="handleEdit"
  >
    {{ displayText }}
  </span>
  <!-- eslint-disable vue/no-v-html -->
  <span
    v-else-if="linkField?.editable"
    v-html="linkField.editable"
  />
  <!-- eslint-enable vue/no-v-html -->
  <a
    v-else-if="linkField?.value?.text || linkField?.value?.href || linkField?.value?.url"
    :href="linkField.value.href || linkField.value.url"
    :target="linkField.value.target || undefined"
    :rel="linkRel"
  >
    <slot v-bind="{ linkField, inlineEditMode }">{{ linkField.value.text }}</slot>
  </a>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';

import { useInlineEdit } from '@/composables/inlineEdit';
import type { LinkField } from '@/sitecoreFieldTypes';

defineOptions({
  name: 'LinkFieldFi',
});

const props = withDefaults(
  defineProps<{
    fieldName?: string | null | undefined;
  }>(),
  {
    fieldName: undefined,
  },
);

const { inlineEditMode, fieldValue, offerEditMode, openLinkEditor, notifyChanges } = useInlineEdit(
  props.fieldName,
);

const linkField = computed(() => fieldValue.value as unknown as LinkField | null);

const linkRel = computed(() => {
  const val = linkField.value?.value;
  if (val?.url && val.target === '_blank') {
    return 'noopener noreferrer';
  }
  return undefined;
});

const editedText = ref<string | null | undefined>(undefined);
const displayText = computed(() => editedText.value ?? linkField.value?.value?.text);

const handleEdit = async () => {
  const result = await openLinkEditor();
  if (result) {
    notifyChanges(true, result);
    const match = result.match(/text="([^"]*)"/);
    editedText.value = match ? match[1] : '';
  }
};
</script>

<style scoped src="./link-field-fi.scss" />
